import Building from './building';

export default Building;
